import { render, staticRenderFns } from "./product_details.vue?vue&type=template&id=22817df8&scoped=true&"
import script from "./product_details.vue?vue&type=script&lang=js&"
export * from "./product_details.vue?vue&type=script&lang=js&"
import style0 from "./product_details.vue?vue&type=style&index=0&id=22817df8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22817df8",
  null
  
)

export default component.exports